import { render, staticRenderFns } from "./VendorProduct.vue?vue&type=template&id=cbda0ff4&scoped=true&"
import script from "./VendorProduct.vue?vue&type=script&lang=js&"
export * from "./VendorProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbda0ff4",
  null
  
)

export default component.exports